<template>
    <!-- Top light beams - responsive positioning -->
    <div
        class="absolute -top-[100px] sm:-top-[150px] lg:-top-[200px] left-1/2 z-50 -translate-x-1/2 flex gap-4 sm:gap-8 lg:gap-16 pointer-events-none">
        <div
            class="w-[60px] sm:w-[80px] lg:w-[120px] h-[400px] sm:h-[600px] lg:h-[800px] bg-[rgba(82,127,201,0.08)] blur-[5px] sm:blur-[8px] lg:blur-[10px] opacity-25">
        </div>
        <div
            class="w-[60px] sm:w-[80px] lg:w-[120px] h-[400px] sm:h-[600px] lg:h-[800px] bg-[rgba(82,127,201,0.08)] blur-[5px] sm:blur-[8px] lg:blur-[10px] opacity-25">
        </div>
        <div
            class="w-[60px] sm:w-[80px] lg:w-[120px] h-[400px] sm:h-[600px] lg:h-[800px] bg-[rgba(82,127,201,0.08)] blur-[5px] sm:blur-[8px] lg:blur-[10px] opacity-25">
        </div>
        <div
            class="w-[60px] sm:w-[80px] lg:w-[120px] h-[400px] sm:h-[600px] lg:h-[800px] bg-[rgba(82,127,201,0.08)] blur-[5px] sm:blur-[8px] lg:blur-[10px] opacity-25">
        </div>
    </div>

    <section
        class="max-w-screen-xl overflow-hidden mx-auto relative pb-12 sm:pb-16 lg:pb-20 z-0 px-4 sm:px-6 lg:px-4 mb-12 sm:mb-16 lg:mb-20">
        <!-- Galaxy Stars Background -->
        <div class="absolute inset-0 -z-10 pointer-events-none">
            <!-- Left Side Stars -->
            <div class="absolute left-0 top-0 w-1/4 sm:w-1/3 h-full">
                <div v-for="star in leftStars" :key="`left-${star.id}`"
                    class="absolute rounded-full bg-white opacity-70" :style="{
                        left: star.x + '%',
                        top: star.y + '%',
                        width: star.size + 'px',
                        height: star.size + 'px',
                        animationDelay: star.delay + 's',
                        animationDuration: star.duration + 's'
                    }" :class="star.twinkle ? 'animate-twinkle' : ''"></div>
            </div>

            <!-- Right Side Stars -->
            <div class="absolute right-0 top-0 w-1/4 sm:w-1/3 h-full">
                <div v-for="star in rightStars" :key="`right-${star.id}`"
                    class="absolute rounded-full bg-white opacity-70" :style="{
                        left: star.x + '%',
                        top: star.y + '%',
                        width: star.size + 'px',
                        height: star.size + 'px',
                        animationDelay: star.delay + 's',
                        animationDuration: star.duration + 's'
                    }" :class="star.twinkle ? 'animate-twinkle' : ''"></div>
            </div>
        </div>

        <!-- Background Circles - responsive positioning and sizing -->
        <div
            class="absolute inset-0 flex items-center top-[400px] sm:top-[500px] lg:top-[770px] justify-center pointer-events-none">
            <!-- Circle 1506px - responsive -->
            <div
                class="absolute w-[800px] sm:w-[1200px] lg:w-[1506px] h-[800px] sm:h-[1200px] lg:h-[1506px] overflow-hidden rounded-full -z-10 bg-[var(--background-primary)]">
                <div
                    class="absolute w-[200px] sm:w-[300px] lg:w-[400px] h-[100px] sm:h-[150px] lg:h-[200px] left-[300px] sm:left-[450px] lg:left-[550px] -top-[150px] sm:top-[250px] lg:-top-[300px] bg-white blur-[50px] sm:blur-[75px] lg:blur-[100px] rounded-lg">
                </div>
            </div>

            <!-- Circle 1212px - responsive -->
            <div
                class="absolute overflow-hidden w-[600px] sm:w-[900px] lg:w-[1212px] z-10 h-[600px] sm:h-[900px] lg:h-[1212px] rounded-full bg-[var(--background-primary)]">
                <div
                    class="absolute w-[200px] sm:w-[300px] lg:w-[400px] h-[100px] sm:h-[150px] lg:h-[200px] left-[200px] sm:left-[300px] lg:left-[450px] -top-[170px] sm:-top-[255px] lg:-top-[340px] bg-white blur-[50px] sm:blur-[75px] lg:blur-[100px] rounded-lg">
                </div>
            </div>

            <!-- Circle 900px - responsive -->
            <div
                class="absolute overflow-hidden w-[450px] sm:w-[675px] lg:w-[900px] z-10 h-[450px] sm:h-[675px] lg:h-[900px] rounded-full bg-[var(--background-primary)]">
                <div
                    class="absolute w-[200px] sm:w-[300px] lg:w-[400px] h-[100px] sm:h-[150px] lg:h-[200px] left-[125px] sm:left-[187px] lg:left-[200px] -top-[170px] sm:-top-[255px] lg:-top-[340px] bg-white blur-[50px] sm:blur-[75px] lg:blur-[100px] rounded-lg">
                </div>
            </div>
        </div>

        <!-- Left gradient blur - responsive -->
        <div
            class="absolute w-[400px] sm:w-[600px] lg:w-[818px] h-[420px] sm:h-[630px] lg:h-[840px] top-[180px] sm:top-[270px] lg:top-[360px] left-[25px] sm:left-[37px] lg:left-[50px] rounded-full bg-[linear-gradient(180deg,#63CF99_0%,#375E4A_100%)] blur-[26px] sm:blur-[40px] lg:blur-[53px]">
        </div>

        <div class="container mx-auto text-center relative z-10 pt-8 sm:pt-12 lg:pt-0">
            <div
                class="gradient-border-mask max-w-max mx-auto  backdrop-blur-sm relative before:rounded-full before:bg-[linear-gradient(95.01deg,#BDB1FF_2.72%,#6952ED_95.35%)]">
                <div class="px-3 py-1 sm:py-2 sm:px-4 text-xs sm:text-base font-medium mb-4 sm:mb-6 tracking-wide bg-[image:var(--primary-gradient)] bg-clip-text text-transparent">
                    Exclusive for Our Backend
                </div>
            </div>

            <!-- Main heading - responsive typography -->
            <h1 class="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold mb-3 sm:mb-4 leading-tight">
                <span class="text-gray-300">Level Up <br class="sm:hidden"> E-commerce!</span>
            </h1>

            <!-- Sub heading - responsive typography -->
            <h2
                class="text-2xl sm:text-4xl md:text-5xl lg:text-7xl pb-2 font-semibold mb-6 sm:mb-8 bg-[image:var(--primary-gradient)] bg-clip-text text-transparent leading-tight">
                Try our composable frontend today.
            </h2>

            <!-- Description - responsive -->
            <p
                class="text-[var(--text-gray)] text-base sm:text-lg lg:text-xl font-medium mb-8 sm:mb-10 lg:mb-12 max-w-lg sm:max-w-xl lg:max-w-2xl mx-auto px-2 sm:px-0">
                Boost Sales with a Seamless Customer Interface & Vendor Dashboard.
            </p>

            <!-- Buttons - responsive layout -->
            <div
                class="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center w-full max-w-[280px] sm:max-w-none mx-auto">
                <!-- Gradient Button -->
                <Button unstyled label="Learn More" iconPos="left" class="group !rounded-xl !px-4 sm:!px-5 
         bg-[image:var(--primary-gradient)] hover:bg-[image:var(--primary-gradient-reverse)]
         transition-all duration-1000 ease-in-out
         !py-2.5 sm:!py-3 font-semibold
         text-[var(--text-secondary)] 
         flex items-center justify-center gap-2 sm:gap-3 
         w-full sm:w-auto text-sm sm:text-base overflow-hidden">

                    <span class="flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 
             rounded-full bg-white 
             transform transition-all duration-1000 ease-in-out 
             group-hover:translate-x-28">
                        <i class="pi pi-angle-right text-green-500 font-bold text-sm sm:text-lg"></i>
                    </span>
                    <span class="transition-all duration-1000 ease-in-out group-hover:-translate-x-1/2">
                        Learn More
                    </span>
                </Button>


                <!-- Secondary Button -->
                <Button unstyled label="Schedule a Demo" icon="pi pi-calendar" :pt="{ icon: { class: '' } }"
                    class="!rounded-xl !px-4 sm:!px-5 bg-[var(--background-btn)] !py-2.5 sm:!py-3 font-semibold text-[var(--text-secondary)] flex items-center justify-center gap-2 sm:gap-3 w-full sm:w-auto text-sm sm:text-base">
                </Button>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
interface Star {
    id: number;
    x: number;
    y: number;
    size: number;
    delay: number;
    duration: number;
    twinkle: boolean;
}

const generateStars = (count: number, startId: number = 0): Star[] => {
    const stars: Star[] = [];

    for (let i = 0; i < count; i++) {
        stars.push({
            id: startId + i,
            x: Math.random() * 100,
            y: Math.random() * 100,
            size: 0.5 + Math.random() * 1.5, // 0.5px to 2px
            delay: Math.random() * 5,
            duration: 2 + Math.random() * 4, // 2s to 6s
            twinkle: Math.random() > 0.3 // 70% chance to twinkle
        });
    }

    return stars;
};

// Generate stars for left and right sides
const leftStars = ref<Star[]>([]);
const rightStars = ref<Star[]>([]);

onMounted(() => {
    // Reduce star count on mobile for better performance
    const starCount = window.innerWidth < 640 ? 75 : window.innerWidth < 1024 ? 100 : 150;
    leftStars.value = generateStars(starCount, 0);
    rightStars.value = generateStars(starCount, starCount);
});

const learnMore = () => {
    console.log("Learn more clicked");
};

const scheduleDemo = () => {
    console.log("Schedule demo clicked");
};
</script>

<style scoped>
@keyframes twinkle {

    0%,
    100% {
        opacity: 0.3;
        transform: scale(0.8);
    }

    50% {
        opacity: 1;
        transform: scale(1.2);
    }
}

.animate-twinkle {
    animation: twinkle infinite ease-in-out;
}

/* Add some glow effect to larger stars */
.absolute.rounded-full.bg-white {
    box-shadow: 0 0 2px rgba(255, 255, 255, 0.8);
}

/* Responsive text sizing for better mobile readability */
@media (max-width: 640px) {
    .container {
        padding-left: 1rem;
        padding-right: 1rem;
    }
}

/* Ensure buttons don't overflow on very small screens */
@media (max-width: 320px) {
    .flex.flex-col.sm\\:flex-row {
        max-width: 100%;
    }
}

.gradient-border-mask::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid transparent;
    background: var(--primary-gradient);
    -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: destination-out;
    mask-composite: exclude;
}
</style>